(function () {
  if (window.__quickAddSizePopupInit) { return; }
  window.__quickAddSizePopupInit = true;

  function closeAllPopups(except) {
    document.querySelectorAll('.quick-add.is-open').forEach(function (el) {
      if (el !== except) { el.classList.remove('is-open'); }
    });
  }

  function addToCart(variantId, triggerEl, wrapper) {
    if (!variantId) { return; }

    wrapper.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        wrapper.classList.remove('is-loading');
        wrapper.classList.remove('is-open');

        if (window.jQuery && window.PXUTheme && window.PXUTheme.jsAjaxCart) {
          window.PXUTheme.jsAjaxCart.showDrawer();
          window.PXUTheme.jsAjaxCart.updateView();
        }
      })
      .catch(function () {
        wrapper.classList.remove('is-loading');
      });
  }

  // IMPORTANT: this listener runs on the CAPTURE phase (top-down), before the
  // click reaches the thumbnail and starts its normal bubble phase. The base
  // theme binds a delegated "tap image to swap secondary photo" handler
  // (window.PXUTheme.thumbnail.showVariantImage) on an ancestor of the product
  // card, intended for touch devices. Without intercepting here first, any
  // click inside .quick-add bubbles up through .has-secondary-image-swap and
  // incorrectly triggers that swap, making the image flip/blank out behind
  // the open popup. Capturing + stopping propagation here keeps quick-add
  // clicks fully isolated from that legacy behavior.
  document.addEventListener('click', function (e) {
    var withinQuickAdd = e.target.closest('.quick-add');
    if (!withinQuickAdd) { return; }

    e.stopPropagation();

    var toggle = e.target.closest('.quick-add__toggle');
    if (toggle) {
      e.preventDefault();
      var wrapper = toggle.closest('.quick-add');
      var hasPopup = wrapper.querySelector('.quick-add__popup');

      if (!hasPopup) {
        addToCart(toggle.getAttribute('data-variant-id'), toggle, wrapper);
        return;
      }

      var isOpen = wrapper.classList.contains('is-open');
      closeAllPopups(wrapper);
      wrapper.classList.toggle('is-open', !isOpen);
      return;
    }

    var closeBtn = e.target.closest('.quick-add__close');
    if (closeBtn) {
      e.preventDefault();
      var closeWrapper = closeBtn.closest('.quick-add');
      if (closeWrapper) { closeWrapper.classList.remove('is-open'); }
      return;
    }

    var sizeBtn = e.target.closest('.quick-add__size');
    if (sizeBtn) {
      e.preventDefault();
      if (sizeBtn.classList.contains('is-unavailable')) { return; }
      var sizeWrapper = sizeBtn.closest('.quick-add');
      addToCart(sizeBtn.getAttribute('data-variant-id'), sizeBtn, sizeWrapper);
      return;
    }
  }, true);

  // Separate bubble-phase listener (normal, not capturing) purely to close
  // any open popup when the user clicks elsewhere on the page.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.quick-add')) {
      closeAllPopups();
    }
  });
})();
